// import Vue from "vue";
// import Vuex from "vuex";

// import adminInfo from "../../../store/rh/adminInfo.js";
// import delayTime from "../../../store/rh/delayTime.js";
// import dirverOrCoopUnit from "../../../store/rh/dirverOrCoopUnit.js";
// import firstPath from "../../../store/rh/firstPath.js";
// import leftMenuZoom from "../../../store/rh/leftMenuZoom.js";
// import privilegeConfig from "../../../store/rh/privilegeConfig.js";
// import socketX from "../../../store/rh/socketX.js";
// import sysTmpObj from "../../../store/rh/sysTmpObj.js";

// Vue.use(Vuex);

// export default new Vuex.Store({
//   state: {},
//   getters: {},
//   mutations: {},
//   actions: {},
//   modules: {
//     adminInfo,
//     delayTime,
//     dirverOrCoopUnit,
//     firstPath,
//     leftMenuZoom,
//     privilegeConfig,
//     socketX,
//     sysTmpObj
//   }
// });

import Vue from "vue";
import Vuex from "vuex";
import io from "socket.io-client";
import { getToken } from "../../../assets/js/util";
import common from "../../../assets/js/common";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // 当前管理员权限
    privilegeConfig: {},
    // 管理员信息
    adminInfo: {},
    // socket消息队列,废弃，不同业务采用独立队列维护，样例socket*对应的数组
    socketMsgList: {},
    // 系统临时变量,对象行使保存，设置值->获取值->清除值，支撑某些连贯操作存储数据
    sysTmpObj: {},
    // 左菜单缩放
    leftMenuZoom: false,
    // 右边宽度计算
    rightMianWidth: 0,
    // 菜单缩放回调执行
    delayTime: 500,
    // 登录后访问的第一个路由
    firstPath: "",
    // socket 對象
    socketObj: undefined,
    // 业务DebugA socket队列
    socketDebugA: [],
    // 业务DebugB socket队列
    socketDebugB: [],
    // socket队列改变
    queueList: [],
    // 当前连接的socketId
    socketId: null,
    // 计入的房间队列
    joinRoomList: [],
    // socket connect 状态
    socketIsDisconnect: false,
    // socket 工作状态，标识部分情况完成后才能重新连接
    socketBsStatu: false,
    // 司机或者合作单位
    dirverOrCoopUnit: false
  },
  getters: {
    privilegeConfig(state) {
      return state.privilegeConfig;
    },
    adminInfo(state) {
      return state.adminInfo;
    },
    socketMsgList(state) {
      return state.socketMsgList;
    },
    sysTmpObj(state) {
      return state.sysTmpObj;
    },
    leftMenuZoom(state) {
      return state.leftMenuZoom;
    },
    rightMianWidth(state) {
      return state.rightMianWidth;
    },
    delayTime(state) {
      return state.delayTime;
    },
    firstPath(state) {
      return state.firstPath;
    },
    socketObj(state) {
      return state.socketObj;
    },
    socketDebugA(state) {
      return state.socketDebugA;
    },
    socketDebugB(state) {
      return state.socketDebugB;
    },
    queueList(state) {
      return state.queueList;
    },
    socketId(state) {
      return state.socketId;
    },
    joinRoomList(state) {
      return state.joinRoomList;
    },
    socketIsDisconnect(state) {
      return state.socketIsDisconnect;
    },
    socketBsStatu(state) {
      return state.socketBsStatu;
    },
    dirverOrCoopUnit(state) {
      return state.dirverOrCoopUnit;
    }
  },
  mutations: {
    setAdminInfo(state, data) {
      state.adminInfo = data;
    },
    pushSocketMsgList(state, data) {
      state.socketMsgList.push(data);
    },
    setSysTmpObj(state, data) {
      if (Object.keys(state.sysTmpObj).length > 0) {
        console.error(
          "vuex sysTmpObj 对象某次使用未释放，请在前一次使用后调用cleanSysTmpObj方法释放，当前不能调用"
        );
      } else {
        state.sysTmpObj = data;
      }
    },
    cleanSysTmpObj(state) {
      state.sysTmpObj = {};
    },
    setLeftMenuZoom(state, data) {
      state.leftMenuZoom = data;
    },
    setPrivilegeConfig(state, data) {
      state.privilegeConfig = data;
    },
    setFirstPath(state, data) {
      state.firstPath = data;
    },
    // Socket发送数据
    sendSocket(state, sendData) {
      state.socketObj.emit(sendData.method, sendData.data);
    },
    // 设置SocketObj
    setSocketObj(state, socket) {
      state.socketObj = socket;
    },
    // 设置SocketOid
    setSocketId(state, id) {
      state.socketId = id;
    },
    // 设置房间列表
    setJoinRoomList(state, data) {
      state.joinRoomList.push(data);
    },
    // 关闭socket
    closeSocket(state) {
      state.socketObj.close();
    },
    // 设置状态
    setSocketIsDisconnect(state, data) {
      state.socketIsDisconnect = data;
    },
    // 设置socket 工作状态
    setSocketBsStatu(state, data) {
      state.socketBsStatu = data;
    },
    setRightMianWidth(state, data) {
      state.rightMianWidth = data;
    },
    // 设置合作单位和司机权限
    setDirverOrCoopUnit(state, data) {
      state.dirverOrCoopUnit = data;
    }
  },
  actions: {
    // 获取权限
    fetchPrivilege({ commit }) {
      return new Promise(resolve => {
        common
          .http({
            method: "get",
            url: "/api/permission/list_mine",
            noLoading: true
          })
          .then(res => {
            // 缓存权限
            commit("setPrivilegeConfig", res.data.data);
            // 缓存司机和合作单位权限
            let keys = res.data.data.keys;
            let dirverOrCoopUnit = false;
            if (
              keys.indexOf("H-dirver-all") >= 0 ||
              keys.indexOf("H-coop-unit-all") >= 0
            ) {
              dirverOrCoopUnit = true;
            }
            commit("setDirverOrCoopUnit", dirverOrCoopUnit);
            // 计算第一个访问的菜单（待完善，结合路由）
            // commit("setFirstPath", "/rhqy/home");
            resolve();
          });
      });
    },
    initSocket({ commit }) {
      return new Promise(resolve => {
        const socket = io("", {
          path: "/sio",
          reconnectionDelayMax: 10000,
          transports: ["websocket"],
          query: {
            auth: getToken()
          }
        });
        socket.on("connect", () => {
          console.log("wb connect", socket.id, socket.connected);
          commit("setSocketId", socket.id);
          commit("setSocketIsDisconnect", true);
          resolve();
        });
        socket.on("disconnect", data => {
          // 应用页面监听该变量，变化时重新获取数据
          commit("setSocketIsDisconnect", false);
          console.error("connect，客户端断网", data);
        });
        socket.on("connect_error", data => {
          console.error("connect_error", data);
        });
        socket.on("agentStateChanged", data => {
          console.log("agentStateChanged", data);
        });
        commit("setSocketObj", socket);
      });
    },
    // 加入房间
    joinRoom({ commit, state }, roomName) {
      return new Promise(resolve => {
        state.socketObj.on("join-room", data => {
          commit("setJoinRoomList", data);
          if (data == roomName) {
            resolve();
          }
        });
        state.socketObj.emit("join-room", roomName);
      });
    },
    // 离开房间
    leaveRoom({ state }, roomName) {
      return new Promise(resolve => {
        state.socketObj.on("leave-room", data => {
          if (data == roomName) {
            resolve();
          }
        });
        state.socketObj.emit("leave-room", roomName);
      });
    }
  },
  modules: {}
});
